import React, { useEffect, useState } from "react";
import api from "../api";
import { usePageTitle } from "../components/common";
import { AVERTISSEMENT, PROPRIETE_INTELLECTUELLE, NATURE_PRESTATIONS, ABSENCE_GARANTIE } from "../content";

const TITLES = {
  mentions: "Mentions légales",
  cgv: "Conditions Générales de Vente",
  confidentialite: "Politique de confidentialité",
  cookies: "Politique relative aux cookies",
  avertissement: "Avertissement",
  mediation: "Médiation de la consommation",
};

function P({ value, label }) {
  if (value) return <>{value}</>;
  return <em className="text-[#a58f92]">[{label} — à compléter dans l'espace administration]</em>;
}
const paras = (t) => t.split("\n\n").map((p, i) => <p key={i} className="whitespace-pre-line">{p}</p>);

export default function Legal({ page }) {
  usePageTitle(TITLES[page]);
  const [s, setS] = useState({});
  useEffect(() => { api.get("/settings/public").then((r) => setS(r.data)).catch(() => {}); }, []);

  const mediationBlock = (
    <>
      <p>
        En cas de litige, le Client consommateur est invité à adresser préalablement une réclamation écrite à
        La Maison de ta Sorcière Préférée ({s.contact_email}).
      </p>
      <p>
        À défaut de résolution amiable, le Client peut recourir gratuitement au médiateur de la consommation
        dont relève le professionnel :
      </p>
      <p>
        <strong>{s.mediator_name || "NotreAccord Consommation"}</strong><br />
        {s.mediator_address || "132 rue Fondaudège, 33000 Bordeaux, France"}<br />
        Téléphone : {s.mediator_phone || "09 79 33 58 27"}<br />
        Email : {s.mediator_email || "consommation@notreaccord.com"}<br />
        <a href={s.mediator_url || "https://mediation-consommation.notreaccord.com"} target="_blank" rel="noreferrer" className="text-[#5A3A4B] underline">
          {s.mediator_url || "https://mediation-consommation.notreaccord.com"}
        </a>
      </p>
      {s.mediator_legal && <p className="text-sm text-[#a58f92]">{s.mediator_legal}</p>}
    </>
  );

  return (
    <div className="container-x py-12 sm:py-20 fade-up max-w-3xl">
      <h1 className="font-serif text-4xl sm:text-5xl font-medium text-[#5A3A4B]">{TITLES[page]}</h1>
      <div className="gold-divider my-7 w-28" />
      <div className="prose-legal" data-testid={`legal-${page}`}>
        {page === "avertissement" && paras(AVERTISSEMENT)}

        {page === "mediation" && mediationBlock}

        {page === "mentions" && (
          <>
            <h3>Éditeur du site</h3>
            <p>
              <P value={s.business_name} label="Nom légal" /> — {s.business_legal_form || "Entrepreneur individuel — Micro-entrepreneur"}<br />
              Marque : {s.brand_name || "La Maison de ta Sorcière Préférée"}<br />
              {s.commercial_name ? <>Nom commercial : {s.commercial_name}<br /></> : null}
              Email : {s.contact_email}<br />
              Téléphone : <P value={s.business_phone} label="Téléphone professionnel" /><br />
              Adresse : <P value={s.business_address} label="Adresse professionnelle" />
              {s.business_postal_code || s.business_city ? <><br />{s.business_postal_code} {s.business_city}, {s.business_country}</> : null}
            </p>
            <p>
              SIREN : <P value={s.siren} label="SIREN" /><br />
              SIRET : <P value={s.siret} label="SIRET" /><br />
              RNE : <P value={s.rne || s.siren} label="RNE" /><br />
              TVA : {s.vat_number ? s.vat_number : (s.vat_status || "TVA non applicable, art. 293 B du CGI")}
            </p>
            <h3>Directrice de la publication</h3>
            <p>{s.director_publication || "Noëmie Sartore"}</p>
            <h3>Hébergeur</h3>
            <p>
              <P value={s.host_name} label="Hébergeur — raison sociale" /><br />
              <P value={s.host_address} label="Hébergeur — adresse" /><br />
              {s.host_phone ? <>Téléphone : {s.host_phone}<br /></> : null}
              {s.host_url ? <a href={s.host_url} target="_blank" rel="noreferrer" className="text-[#5A3A4B] underline">{s.host_url}</a> : null}
            </p>
            <h3>Propriété intellectuelle</h3>
            {paras(PROPRIETE_INTELLECTUELLE)}
            <h3>Médiation de la consommation</h3>
            {mediationBlock}
          </>
        )}

        {page === "confidentialite" && (
          <>
            <h3>Responsable du traitement</h3>
            <p>{s.business_name || "SARTORE Noëmie"} — {s.contact_email}</p>
            <h3>Données de facturation</h3>
            <p>Nom, prénom, adresse, email et, le cas échéant, informations professionnelles (raison sociale, SIREN, TVA). Ces données sont utilisées pour la facturation et transmises uniquement au service de facturation (Henrri) dans la stricte mesure nécessaire.</p>
            <h3>Données de séance privées</h3>
            <p>
Les données nécessaires à la préparation et à la réalisation d’une guidance peuvent comprendre :
nom, prénom, date de naissance, heure de naissance lorsqu’elle est connue, ville et pays de naissance,
sujet de la guidance, question ou situation à explorer, attentes exprimées par la cliente,
consentements recueillis, ainsi que les éventuelles informations, photos et notes privées transmises
dans le cadre de la prestation.

Ces données sont utilisées exclusivement pour préparer, réaliser et assurer le suivi de la prestation
achetée. Elles restent confidentielles et ne sont accessibles qu’à la cliente concernée et à Noëmie Sartore.

Elles ne sont pas transmises à Stripe, Henrri ou Cal.com, à l’exception des informations strictement
nécessaires au fonctionnement du service concerné.
</p>
            <h3>Confidentialité des photos</h3>
            <p>La photo transmise est utilisée uniquement dans le cadre de la prestation réservée. Elle n'est jamais publiée ni utilisée à des fins commerciales. Elle est stockée de manière privée et automatiquement supprimée 7 jours après le passage de la séance au statut « Terminée ».</p>
            <h3>Durée de conservation</h3>
            <p>
Les données liées à la préparation et à la réalisation de la séance sont conservées pendant la durée nécessaire à l’exécution et au suivi de la prestation, puis supprimées ou anonymisées lorsqu’elles ne sont plus nécessaires, sous réserve des obligations légales de conservation applicables.

Les photos transmises sont supprimées 7 jours après la fin de la séance.

Les données de facturation sont conservées conformément aux obligations comptables et fiscales.
</p>
            <h3>Tes droits</h3>
            <p>Tu disposes d'un droit d'accès, de rectification, d'effacement et d'opposition. Tu peux les exercer via la page <a href="/mes-donnees" className="text-[#5A3A4B] underline">Mes données personnelles</a> ou en écrivant à {s.contact_email}.</p>
            <p>Tu peux également introduire une réclamation auprès de la CNIL (Commission Nationale de l'Informatique et des Libertés).</p>
          </>
        )}

        {page === "cookies" && (
          <>
            <h3>Cookies utilisés</h3>
            <p>Ce site utilise uniquement des cookies strictement nécessaires à son fonctionnement : authentification, sécurité, checkout, session et fonctionnement technique. Aucun cookie publicitaire ni traceur marketing n'est utilisé dans cette version.</p>
            <h3>Consentement</h3>
            <p>Les cookies strictement nécessaires ne requièrent pas de consentement préalable. Si un outil marketing ou de mesure d'audience non essentiel était ajouté ultérieurement, il serait bloqué tant que ton consentement n'aurait pas été recueilli.</p>
            <h3>Gestion</h3>
            <p>Tu peux configurer ton navigateur pour limiter ou supprimer les cookies. Certaines fonctionnalités (connexion, paiement) pourraient alors ne plus fonctionner.</p>
          </>
        )}

        {page === "cgv" && (
          <>
            <p className="text-xs text-[#a58f92]">Version {s.cgv_version || "1.0"}</p>
            {[
              ["Identité du prestataire", <>Les présentes conditions régissent les prestations proposées par <P value={s.business_name} label="Nom légal" />, {s.business_legal_form || "Entrepreneur individuel — Micro-entrepreneur"}, joignable à {s.contact_email}. SIREN : <P value={s.siren} label="SIREN" /> · SIRET : <P value={s.siret} label="SIRET" />. {s.vat_number || s.vat_status}.</>],
              ["Objet", "Les présentes CGV définissent les conditions de vente des guidances intuitives, lectures d'oracles, séances de médiumnité et séances énergétiques proposées à distance."],
              ["Description des prestations", "Les prestations sont détaillées sur chaque page de service, avec leur prix et, le cas échéant, leur durée."],
              ["Nature spirituelle et non médicale", NATURE_PRESTATIONS],
              ["18 ans minimum", "Toutes les prestations sont exclusivement réservées aux personnes âgées de 18 ans ou plus. La cliente confirme sa majorité avant tout paiement."],
              ["Commande", "La commande est validée après acceptation des CGV et des consentements obligatoires, puis paiement en ligne."],
              ["Prix", "Les prix sont indiqués en euros et exigibles au moment de la commande. Les montants sont validés côté serveur."],
              ["Paiement", "Le paiement s'effectue en ligne de manière sécurisée via Stripe."],
              ["Informations du Client", "La cliente s'engage à fournir des informations exactes : prénom, nom, photo récente conforme et, selon la prestation, question ou intention."],
              ["Photo", "La photo est utilisée uniquement dans le cadre de la prestation, n'est jamais publiée ni utilisée commercialement, et est supprimée 7 jours après la fin de la séance."],
              ["Organisation des séances", "Les séances sont réalisées à distance, au moment prévu, sans présence requise de la cliente."],
              ["Absence d'appel et de visioconférence", "Aucune prestation ne comporte d'appel téléphonique ni de visioconférence."],
              ["Réservation Cal.com", "Lorsque la prestation le nécessite, un créneau est réservé après le paiement via l'outil Cal.com. Ce créneau correspond au moment où Noëmie réalise la séance de son côté."],
              ["SOS Sorcière", "La prestation SOS Sorcière porte sur une seule question précise, ne nécessite aucune réservation, et la réponse est envoyée sous 24 heures maximum après réception des informations nécessaires."],
              ["Compte rendu", "Le compte rendu est transmis par WhatsApp ou par e-mail, selon la préférence de la cliente."],
              ["Délais", "Les délais d'exécution dépendent de la prestation et courent à compter de la réception de l'ensemble des informations nécessaires."],
              ["Annulation / report", "Toute demande de report doit être adressée dans un délai raisonnable avant la séance et reste soumise aux disponibilités."],
              ["Droit de rétractation", "La cliente consommatrice dispose d'un délai de rétractation de 14 jours pour les prestations de services, sauf renonciation expresse en cas d'exécution anticipée. La demande peut être exercée via la page Rétractation."],
              ["Exécution anticipée", "La cliente peut demander expressément l'exécution de la prestation avant la fin du délai de rétractation et reconnaît perdre ce droit une fois la prestation entièrement exécutée."],
              ["Absence de garantie de résultat", ABSENCE_GARANTIE],
              ["Libre arbitre et responsabilité", "La cliente demeure pleinement responsable de ses choix et décisions. Une guidance peut éclairer un chemin, elle ne le choisit jamais à sa place."],
              ["Propriété intellectuelle", PROPRIETE_INTELLECTUELLE],
              ["Données personnelles", "Les données sont traitées conformément à la Politique de confidentialité. Les données privées de séance ne sont jamais transmises aux prestataires de facturation, de paiement ou de réservation."],
              ["Force majeure", "La responsabilité de la prestataire ne saurait être engagée en cas de force majeure."],
              ["Réclamations", <>Toute réclamation peut être adressée à {s.contact_email} ou via la page <a href="/reclamations" className="text-[#5A3A4B] underline">Réclamations</a>.</>],
              ["Médiation NotreAccord", mediationBlock],
              ["Droit applicable", "Les présentes CGV sont soumises au droit français."],
              ["Modifications des CGV", "Les CGV peuvent être modifiées à tout moment. La version applicable est celle acceptée au moment de la commande ; sa version et son horodatage sont conservés."],
            ].map(([h, body], i) => (
              <React.Fragment key={i}>
                <h3>{i + 1}. {h}</h3>
                {typeof body === "string" ? paras(body) : <p>{body}</p>}
              </React.Fragment>
            ))}
          </>
        )}
      </div>
    </div>
  );
}
